//Reference: https://www.w3.org/WAI/tutorials/menus/flyout/
export default class SectionNav {
	constructor() {
		this.node = document.querySelector('.section-nav');

		if (!this.node) {
			return;
		}

		this.menuItems = this.node.querySelectorAll('li.has-subnav');
		let firstSub = this.node.querySelector('.has-subnav');
		let menuToggle = this.node.querySelector('.section-nav__toggle');

		Array.prototype.forEach.call(this.menuItems, function (el, i) {
			const btn = el.querySelector('.menu-toggle');

			btn.addEventListener("click", function (event) {
				const parent = this.parentNode;
				if (parent.classList.contains("has-subnav") && parent.classList.contains("open")) {
					parent.classList.remove("open");
					//console.log(this.nextElementSibling);
					if (this.nextElementSibling.matches('a')) {
						this.nextElementSibling.setAttribute('aria-expanded', "false");
					}
					this.setAttribute('aria-expanded', "false");
				} else {
					parent.classList.add("open");
					if (this.nextElementSibling.matches('a')) {
						this.nextElementSibling.setAttribute('aria-expanded', "true");
					}
					this.setAttribute('aria-expanded', "true");
				}
				event.preventDefault();
			});
		});

		this.node.addEventListener('mouseleave', function () {
			firstSub.classList.remove('open');
			menuToggle.setAttribute('aria-expanded', "false");
		});

		this.node.addEventListener('focusout', function () {
			setTimeout(() => {
				let focused = this.querySelector(':focus');
				if (focused === null) {
					firstSub.classList.remove('open');
					menuToggle.setAttribute('aria-expanded', "false");
				}
			}, 100);

		});
	}
}
//Clarify: is this menu supposed to be fixed/sticky like our example? Did we discuss that with the client and that content would be 'covered'?
